import {PointMidpointConstraint} from '../point/PointMidpointConstraint';

/**
 * 判断对象是否为兼容中点关系。
 * @param value 待判断对象。
 * @returns 是否为兼容中点关系。
 */
export function isMidpointConstraint(value: object): value is MidpointConstraint {
    return Reflect.get(value, 'isMidpointConstraint') === true;
}

/**
 * 中点关系兼容类型标记。
 *
 * 旧线目录导出继续承载持久关系构造；几何计算完全复用统一中点公式。
 */
export class MidpointConstraint extends PointMidpointConstraint {
    /** 运行时类型标记。 */
    public readonly isMidpointConstraint = true;
}
